import { HeadTagsConfig } from '@tenants/types/tenant';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';

export function createHeadTagsConfig(): HeadTagsConfig {
  return {
    defaultTitle: 'eXp Commercial Brokerage',
    defaultMetaDescriptionKey: LOCALE_EXP_COMMERCIAL_PATHS.HEAD_TAGS_DEFAULT_META_DESCRIPTION,
  };
}

